import { TextField, Grid } from "@mui/material";
import MediaSelector from "./headers/MediaSelector";

const HeaderInputs = ({ template, header, onHeaderChange }) => {
  const headerComponent = template.components.find((c) => c.type === "HEADER");

  if (!headerComponent) return null;

  switch (headerComponent.format?.toUpperCase()) {
    case "TEXT":
      return headerComponent?.example ? (
        <TextField
          fullWidth
          label="Header Param value"
          name="param"
          value={header?.param ?? ""}
          onChange={(e) => onHeaderChange?.({ param: e.target.value })}
          margin="normal"
        />
      ) : null;

    case "IMAGE":
    case "VIDEO":
    case "DOCUMENT":
      return (
        <MediaSelector
          onChange={(newV) => {
            onHeaderChange?.({
              mediaUrl: newV.url,
              id: newV.mediaId,
              filename: newV.fileName,
            });
          }}
          type={headerComponent.format.toLowerCase()}
        />
      );

    case "LOCATION":
      return (
        <>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Latitude"
                name="latitude"
                value={header?.latitude ?? ""}
                onChange={(e) => onHeaderChange?.({ latitude: e.target.value })}
                margin="normal"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Longitude"
                name="longitude"
                value={header?.longitude ?? ""}
                onChange={(e) =>
                  onHeaderChange?.({ longitude: e.target.value })
                }
                margin="normal"
              />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            label="Location Name (optional)"
            name="name"
            value={header?.name ?? ""}
            onChange={(e) => onHeaderChange?.({ name: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Address (optional)"
            name="address"
            value={header?.address ?? ""}
            onChange={(e) => onHeaderChange?.({ address: e.target.value })}
            margin="normal"
          />
        </>
      );

    default:
      return null;
  }
};

export default HeaderInputs;
